import { useEffect, useState } from "react";
import { motion, Variants } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import bannerWallpaper from "@/assets/wallpaper-2.webp";
import lineGroup1 from "@/assets/line-group-1.png";
import lineGroup2 from "@/assets/line-group-2.png";
import lineGroupMulti from "@/assets/line-group-multi.png";
import RotatingLabel from "@//components/common/RotatingLabel";
import Button from "@/components/common/buttons/Button";
import "./banner-section.css";

const BannerSection = () => {
  const [hasRendered, setHasRendered] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const raf = requestAnimationFrame(() => {
      setHasRendered(true);
    });

    return () => cancelAnimationFrame(raf);
  }, []);
  const slideFromLeft: Variants = {
    hidden: { x: "-100%" },
    visible: { x: "0%", transition: { duration: 0.9, ease: [0, 0, 0.2, 1] } },
  };

  const slideFromRight: Variants = {
    hidden: { x: "100%" },
    visible: { x: "0%", transition: { duration: 0.9, ease: [0, 0, 0.2, 1] } },
  };

  const visibleNow: Variants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 1.2, ease: [0, 0, 0.2, 1], delay: 1.5 },
    },
  };

  return (
    <Container className="banner-container">
      <Row className="banner-content">
        <img className="line-group-multi" src={lineGroupMulti} alt="" />
        <img className="line-group-1" src={lineGroup1} alt="" />

        <Col xs={12} lg={6} className="banner-services">
          <motion.div
            initial="hidden"
            animate={hasRendered ? "visible" : "hidden"}
            variants={slideFromLeft}
          >
            <h1 className="title-1 banner-text">
              SERVICII
              <br />
              ONLINE
              <br />
              PREMIUM
            </h1>
            <div className="banner-labels">
              <Button 
                text="MAGAZINE ONLINE" 
                className="firstbuttons magazine-online-button"
                onClick={() => navigate('/servicii/e-commerce')}
              />
              <Button 
                text="WEBSITE-URI" 
                className="firstbuttons website-uri-button"
                onClick={() => navigate('/servicii/web-design')}
              />
              <Button 
                text="ONLINE MARKETING" 
                className="firstbuttons marketing-button"
                onClick={() => navigate('/servicii/online-marketing')}
              />
              <Button 
                text="SERVERSIDE TRACKING" 
                className="firstbuttons serverside-tracking-button"
                onClick={() => navigate('/servicii/serverside-tracking')}
              />
            </div>
          </motion.div>
        </Col>

        <Col xs={12} lg={6} className="banner-image">
          <motion.div
            initial="hidden"
            animate={hasRendered ? "visible" : "hidden"}
            variants={slideFromRight}
            className="banner-motion"
          >
            <div className="banner-wallpaper-wrapper">
              <img className="banner-wallpaper" src={bannerWallpaper} alt="Pixado agency services showcase" />
            </div>

            <motion.div
              initial="hidden"
              animate={hasRendered ? "visible" : "hidden"}
              variants={visibleNow}
              className="rotating-label-container"
            >
              <RotatingLabel />
            </motion.div>
            <motion.div
              initial="hidden"
              animate={hasRendered ? "visible" : "hidden"}
              variants={visibleNow}
              className="projects-count-container"
            >
              <div className="menu-body-bold projects-count">50+</div>
              <div className="projects-text">
                Proiecte finalizate cu succes{" "}
                <span className="alaturi">alaturi de pixado</span>
              </div>
            </motion.div>
          </motion.div>
          <img className="line-group-2" src={lineGroup2} alt="" />
        </Col>
      </Row>
    </Container>
  );
};

export default BannerSection;
